// extracted by mini-css-extract-plugin
export default {"continueBtn":"enable-group-gift-modal__continueBtn__iYgRq"};